import { useState, useEffect } from "react";
import roles from "../../data/roles";

function TypingRole() {
  const [roleIndex, setRoleIndex] = useState(0);
  const [characterIndex, setCharacterIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const currentRole = roles[roleIndex];
  const displayedText = currentRole.slice(0, characterIndex);

  useEffect(() => {
    let delay;

    if (!isDeleting && characterIndex === currentRole.length) {
      delay = 1800;
    } else if (isDeleting) {
      delay = 45;
    } else {
      delay = 85;
    }

    const timeoutId = setTimeout(() => {
      if (!isDeleting && characterIndex === currentRole.length) {
        setIsDeleting(true);
        return;
      }

      if (isDeleting && characterIndex === 0) {
        setIsDeleting(false);
        setRoleIndex((currentIndex) => (currentIndex + 1) % roles.length);
        return;
      }

      setCharacterIndex((currentIndex) =>
        isDeleting ? currentIndex - 1 : currentIndex + 1,
      );
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [characterIndex, currentRole, isDeleting]);

  return (
    <span className="typing-role">
      {displayedText}

      <span className="typing-cursor" aria-hidden="true">
        |
      </span>
    </span>
  );
}

export default TypingRole;
